import * as EnvConstants from '../Constants/EnvConstants';
import axios from 'axios';

export const saveSingleEndPointLogAPI = async (payload) => {
  const res = await axios.post(
    `${EnvConstants.AppLogHistoryEndpointApi}/v1/save-single-end-point-log`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${EnvConstants.AppAdtopiaToken}`,
      },
    }
  );

  return res?.data;
};